import styled from 'styled-components'
import {
  Title as BonsaiTitle,
  tokens,
  Button as BonsaiButton
} from '@arvoreeducacao/bonsai-ds'

export const Container = styled.div`
  background-color: ${tokens.colors.white};
  border-radius: ${tokens.radius.xlarge};
  width: calc(100% - 40px);
  margin: ${tokens.spacing.spacing_56}px 16px;

  display: grid;
  grid-auto-columns: 1fr;

  grid-template-columns: 1fr;
  grid-template-rows: 1fr min-content auto auto min-content;
  gap: 8px 0px;
  grid-template-areas:
    'image'
    'news'
    'title'
    'description'
    'button';

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    width: 100%;
    margin: ${tokens.spacing.spacing_56}px 0px;
    padding-right: ${tokens.spacing.spacing_16}px;

    gap: 0px 0px;
    grid-template-columns: 1fr min-content;
    grid-template-rows: 1fr min-content min-content 1fr;
    grid-template-areas:
      'image news'
      'image title'
      'image description'
      'image button';
  }

  @media (min-width: ${tokens.breakpoints.desktop}px) {
    padding: 0 ${tokens.spacing.spacing_24}px;

    grid-template-columns: min-content 50% min-content;
    grid-template-rows: 1fr 1fr;
    grid-template-areas:
      'news image description'
      'title image button';
    justify-content: space-around;
  }

  @media (min-width: ${tokens.breakpoints.desktopLarge}px) {
    padding: 0 ${tokens.spacing.spacing_56}px;
  }
`

export const Title = styled(BonsaiTitle)`
  grid-area: title;
  margin: 0 ${tokens.spacing.spacing_32}px;

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    margin: 0px;
    margin-top: ${tokens.spacing.spacing_8}px;
  }

  @media (min-width: ${tokens.breakpoints.desktop}px) {
    width: 130px;
    align-self: start;
    margin-top: -${tokens.spacing.spacing_32}px;
  }

  @media (min-width: ${tokens.breakpoints.desktopLarge}px) {
    margin-top: -${tokens.spacing.spacing_32}px;
  }
`

export const NewTag = styled(BonsaiTitle)`
  grid-area: news;
  align-self: flex-end;

  color: ${tokens.colors.tertiary};
  border-bottom: 2px solid ${tokens.colors.tertiary};
  padding-bottom: 1px;
  width: fit-content;
  height: fit-content;

  margin: ${tokens.spacing.spacing_32}px 0px 0px ${tokens.spacing.spacing_32}px;

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    margin: 0px;
  }

  @media (min-width: ${tokens.breakpoints.desktop}px) {
    align-self: center;
  }
`

export const Description = styled.p`
  align-self: flex-end;

  grid-area: description;
  width: min(100%, 260px);
  margin: 0 ${tokens.spacing.spacing_32}px;
  font-size: ${tokens.fontSize.medium}px;
  color: ${tokens.colors.dark5};

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    margin: 0px;
    margin-top: ${tokens.spacing.spacing_8}px;
    width: min(100%, 280px);
    min-width: 280px;
  }

  @media (min-width: ${tokens.breakpoints.desktop}px) {
    margin-top: ${tokens.spacing.spacing_32}px;
    margin-bottom: -${tokens.spacing.spacing_8}px;
  }

  @media (min-width: ${tokens.breakpoints.desktopLarge}px) {
    width: min(100%, 330px);
  }
`

export const Button = styled(BonsaiButton)`
  grid-area: button;

  width: fit-content;
  margin: ${tokens.spacing.spacing_8}px 0px ${tokens.spacing.spacing_32}px
    ${tokens.spacing.spacing_32}px;

  height: 32px;

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    height: fit-content;
    margin: ${tokens.spacing.spacing_12}px 0 ${tokens.spacing.spacing_32}px 0;
  }

  @media (min-width: ${tokens.breakpoints.desktop}px) {
    margin: ${tokens.spacing.spacing_16}px 0 0 0;
  }
`

export const ImageContainer = styled.div`
  grid-area: image;

  display: flex;
  place-content: center;
`

export const Image = styled.img<{
  mobileImageUrl: string
  tabletImageUrl: string
  desktopImageUrl: string
}>`
  content: url(${props => props.mobileImageUrl});
  width: 100%;
  height: 100%;
  object-fit: fill;

  border-top-left-radius: ${tokens.radius.xlarge};
  border-top-right-radius: ${tokens.radius.xlarge};

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    content: url(${props => props.tabletImageUrl});

    border-top-left-radius: ${tokens.radius.xlarge};
    border-bottom-left-radius: ${tokens.radius.xlarge};
    border-top-right-radius: 0;
  }

  @media (min-width: ${tokens.breakpoints.desktop}px) {
    max-width: 460px;
    content: url(${props => props.desktopImageUrl});
  }
`
